import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GoogleTagManager from './GoogleTagManager';

export default class GoogleTagManagerWrapper extends Component {
  render() {
    if (this.props.config.gtm_ids && Array.isArray(this.props.config.gtm_ids)) {
      return (
        <>
          {this.props.config.gtm_ids.map((id) => (
            <GoogleTagManager key={id} config={{ id }} />
          ))}
        </>
      );
    }

    return (
      <GoogleTagManager config={this.props.config} />
    );
  }
}

GoogleTagManagerWrapper.propTypes = {
  config: PropTypes.object.isRequired,
};
